<template>
  <b-container fluid>
    <b-row>
      <b-col lg="10" sm="10" offset-lg="1">
        <iq-card>
            <template v-slot:body>
              <b-overlay :show="loading">
                  <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                      <b-form  @submit.prevent="handleSubmit(verifyPayment)" @reset.prevent="reset">
                          <b-row>
                              <b-col lg="12" sm="12">
                                  <table class="table table-bordered">
                                      <tr>
                                          <td>{{ $t('production_service_config.dealer_name') }}</td>
                                          <td>{{ ($i18n.locale === 'bn') ? formData.name_bn : formData.name_en }}</td>
                                      </tr>
                                      <tr>
                                          <td>{{ $t('externalUser.amount') }}</td>
                                          <td>10000 <span>Tk</span></td>
                                      </tr>
                                      <tr>
                                          <td>{{ $t('externalUser.voucher_no') }}</td>
                                          <td>{{ formData.voucher_no }}</td>
                                      </tr>
                                      <tr>
                                          <td>{{ $t('externalUser.upload_voucher') }}</td>
                                          <td>
                                            <b-img style='width:300px' fluid :src="baseUrl + 'download-attachment?file=uploads/security_payment/original/' + formData.voucher"  alt="Right image"></b-img>
                                          </td>
                                      </tr>
                                  </table>
                              </b-col>
                          </b-row>
                          <div class="row">
                              <div class="col-md-12 text-right">
                                  <b-button type="submit" variant="primary" class="mr-2">{{ $t('globalTrans.verify') }}</b-button>
                                  <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-verify')">{{ $t('globalTrans.cancel') }}</b-button>
                              </div>
                          </div>
                      </b-form>
                  </ValidationObserver>
              </b-overlay>
            </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<style lang="scss" scoped>
    .form-for-textarea textarea{ line-height: 18px !important;height: 54px !important; }
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    /* Firefox */
    input[type=number] {
      -moz-appearance: textfield;
    }
</style>

<script>
import { mapGetters } from 'vuex'
import { core } from '@/config/pluginInit'
import { ValidationObserver } from 'vee-validate'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { offlinePaymentVerify } from '../../api/routes'

export default {
  props: ['id'],
  components: {
    ValidationObserver
  },
  data () {
    return {
      saveBtnName: this.$t('globalTrans.save'),
      loading: false,
      formData: {
        voucher: []
      },
      tmpUrl: '',
      baseUrl: productionServiceBaseUrl
    }
  },
  computed: {
    ...mapGetters({
        productCommonObj: 'ProductionService/commonObj'
    })
  },
  created () {
    this.getSecPayment()
  },
  mounted () {
    core.index()
  },
  methods: {
    verifyPayment () {
      this.loading = true
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.putData(productionServiceBaseUrl, `${offlinePaymentVerify}/${this.id}`).then(response => {
        if (response.success) {
          this.loading = false
          this.$toast.success({
            title: 'Success',
            message: 'Payment verify success.',
            color: '#D6E09B'
          })
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: true })
          this.$bvModal.hide('modal-verify')
        }
      })
    },
    getSecPayment () {
       this.loading = true
        RestApi.getData(productionServiceBaseUrl, `dealer-retailer-management/security-payment/get-sec-payment/${this.id}`).then(response => {
          if (response.success) {
            this.formData = response.data
          }
          this.loading = false
        })
    }
  }
}
</script>
